import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _nodeViewRenderers;
var _excluded = ["node", "nodeIndex", "NodeViewContainer"],
  _excluded2 = ["node"],
  _excluded3 = ["node", "nodeIndex", "NodeViewContainer"],
  _excluded4 = ["node"];
import loadable from "@loadable/component";
import React, { useMemo } from "react";
import { Node_Type } from "./../../ricos-types";
var LinkPreviewRenderer = function LinkPreviewRenderer(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var LinkPreview = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_linkPreview";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import(/* webpackChunkName: "ricos_plugin_linkPreview" */"./link-preview-loadable");
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./link-preview-loadable");
        }
        return eval('require.resolve')("./link-preview-loadable");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(LinkPreview, _extends({
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var LinkPreviewLoadable = function LinkPreviewLoadable(_ref2) {
  var node = _ref2.node,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /* @__PURE__ */React.createElement(LinkPreviewRenderer, _extends({
    key: node.id,
    node: node
  }, props));
};
var EmbedRenderer = function EmbedRenderer(_ref3) {
  var node = _ref3.node,
    nodeIndex = _ref3.nodeIndex,
    NodeViewContainer = _ref3.NodeViewContainer,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  var Embed = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_linkPreview_embed";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import(/* webpackChunkName: "ricos_plugin_linkPreview_embed" */"./embed-loadable");
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./embed-loadable");
        }
        return eval('require.resolve')("./embed-loadable");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(Embed, _extends({
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var EmbedRendererLoadable = function EmbedRendererLoadable(_ref4) {
  var node = _ref4.node,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /* @__PURE__ */React.createElement(EmbedRenderer, _extends({
    key: node.id,
    node: node
  }, props));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.LINK_PREVIEW] = LinkPreviewLoadable, _nodeViewRenderers[Node_Type.EMBED] = EmbedRendererLoadable, _nodeViewRenderers);
export { nodeViewRenderers };